module.exports = __webpack_public_path__ + "4f34a9d1abe522f710993cc80e99df4d.jpg";